import { render, staticRenderFns } from "./VoiceSearchModal.vue?vue&type=template&id=665e73d3&scoped=true&"
import script from "./VoiceSearchModal.vue?vue&type=script&lang=js&"
export * from "./VoiceSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSearchModal.vue?vue&type=style&index=0&id=665e73d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e73d3",
  null
  
)

export default component.exports